export default __webpack_public_path__ + "static/media/punkt_04.31c3d765.svg";